'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { MomentumScroll } from './lib/MomentumScroll'
import { HeaderSize } from './lib/HeaderSize'
import { ContainerOver } from './lib/ContainerOver'
import { Graph } from './lib/Graph'
import { EndlessSlider } from './lib/EndlessSlider'
import { Gallery } from './lib/Gallery'
import { Loading } from './lib/Loading'
import { About } from './lib/About'
import { FlexibleSlider } from './lib/FlexibleSlider'
import { DatePicker } from './lib/DatePicker'
import { EventExpiry } from './lib/EventExpiry'

// new CookiePolicy('optout')
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new MomentumScroll()
new HeaderSize()
new ContainerOver()
new Graph()
new EndlessSlider()
new Gallery()
new Loading()
new About()
new FlexibleSlider()
new DatePicker()
new EventExpiry()